module.exports = __webpack_public_path__ + "assets/img/20_66.7b357838.jpg";